/**
 * Utilities for formatting data
 */

/**
 * Format a number as currency
 * @param value - Number to format
 * @param currency - Currency code (default: CAD)
 * @returns Formatted currency string
 */
export const formatCurrency = (value: number | undefined, currency: string = 'CAD'): string => {
  // Handle undefined or NaN values
  if (value === undefined || isNaN(value)) {
    return `0.00 ${currency}`;
  }
  return `${value.toFixed(2)} ${currency}`;
};

/**
 * Format a date string from YYYY-MM-DD to DD/MM/YYYY
 * @param dateString - Date string in YYYY-MM-DD format
 * @returns Formatted date string in DD/MM/YYYY format
 */
export const formatDate = (dateString: string | undefined): string => {
  if (!dateString) {
    return '';
  }
  
  try {
    const [year, month, day] = dateString.split('-');
    return `${day}/${month}/${year}`;
  } catch (error) {
    console.error('Error formatting date:', error);
    return dateString;
  }
};

/**
 * Calculate totals from report data
 * @param data - Array of data with numeric fields
 * @param fields - Fields to sum
 * @returns Object with totals for each field
 */
export const calculateTotals = <T>(data: T[], fields: (keyof T)[]): Record<string, number> => {
  const totals: Record<string, number> = {};
  
  fields.forEach(field => {
    totals[field as string] = data.reduce((sum, item) => {
      const value = item[field];
      return sum + (typeof value === 'number' ? value : 0);
    }, 0);
  });
  
  return totals;
};
